import { render, staticRenderFns } from "./Processing.vue?vue&type=template&id=54644c0b&scoped=true"
import script from "./Processing.vue?vue&type=script&lang=js"
export * from "./Processing.vue?vue&type=script&lang=js"
import style0 from "./Processing.vue?vue&type=style&index=0&id=54644c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54644c0b",
  null
  
)

export default component.exports